const dotC4 = (a, b, c, d) => a * b + c * d;
const dotC6 = (a, b, c, d, e, f) => a * b + c * d + e * f;
const dotC8 = (a, b, c, d, e, f, g, h) => a * b + c * d + e * f + g * h;
export {
  dotC4,
  dotC6,
  dotC8
};
